import { createStore } from "jotai";

/**
 * Shared Jotai store instance used across the application.
 *
 * This store is shared between:
 * - React components (via JotaiProvider)
 * - Non-React services (e.g., route guards, loaders)
 *
 * Using a single shared store ensures consistency between
 * React component state and service-level state access.
 */
export const globalStore = createStore();
